import React, { Component } from 'react';
import OrderResultView from './OrderResultView'
import { clearOrder, getOrderCache, order_key } from '../../utils/order_cache';
import { callCartItemListeners, callRefreshMyOrderListeners } from '../../utils/common';
function OrderResultController(props) {

    const onClearOrder = async() =>{
        callRefreshMyOrderListeners();
        clearOrder();
        callCartItemListeners();
        props.onClose();
        //this.props.refreshMyOrders();
    }


    return (
        <OrderResultView
            open={props.open}
            onClose={onClearOrder}
            carts={getOrderCache(order_key.cart)}
            estimate_order_result={getOrderCache(order_key.estimate_order_result)}
            delivery_address={getOrderCache(order_key.delivery_address)}
            pick_up_store={getOrderCache(order_key.pick_up_store)}
            order_type={getOrderCache(order_key.order_type,true)}
            order_result={props.order_result}
        />
    );
}

export default OrderResultController;